<template>
    <div class="title">
        <h2><slot name="title"><slot name="spreadhead">{{title}}</slot></slot></h2>
        <p><slot><slot name="subtitle">{{subtitle}}</slot></slot></p>
    </div>
</template>
<script>
export default {
    props:["title","subtitle"]
}
</script>
<style lang="scss" scoped>
    .title{
        width: 100%;
        min-height: 198px;
        padding: 24px 40px 40px;
        box-sizing: border-box;
        h2{
            @include line-height(84px);
            font-size: 60px;
            color: #1B1C1E;
            font-weight: 500;
            @include ellipsis;
        }
        p{
            height: auto;
            font-size: 32px;
            color: #8B8C8D;
            font-weight: 400;
            line-height: 44px;
            margin-top: 6px;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
        }
    }
</style>